import { render, staticRenderFns } from "./SimpleListFactory.vue?vue&type=template&id=7fdd6806"
import script from "./SimpleListFactory.vue?vue&type=script&lang=js"
export * from "./SimpleListFactory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports